import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCacheBuster } from 'react-cache-buster';
import { useLocation } from 'react-router';
// mui
import Container from '@mui/material/Container';
import TopBackButton from '@/component/common/top-back-button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import RandomKeypad from '@/component/common/random-keypad';
import SecretNumberDisplay from '@/component/common/secret-number-display';
// component
import { toast } from 'react-toastify';
import { keepEmail } from '@/component/users/common/keepEmail';
import { IDTOKEN } from '@/component/common/defineName';
import SendMailDrawer from '@/component/auth/send-mail-drawer';
import ArrowLinkButton from '@/component/common/arrow-link-button';
import Erc20Token from '@/component/send/Erc20Token';
import BaseCoin from '@/component/send/BaseCoin';
import Erc721Token from '@/component/send/Erc721Token';
// api
import { loginProps } from '@/api/server/user/read';
import { pinLogin } from '@/component/users/login';
import ErrorRes from '@/api/server/ErrorRes';
import { updatePin, updatePushToken } from '@/api/server/user/update';
import { chkPin, resetPinNum } from '@/api/server/common/auth';
// hook
import { useWeb3 } from '@/hooks/use-web3';
import { useWeb3AuthConnect, useWeb3AuthUser } from '@web3auth/modal/react';
// lib & storage
import { localGetStorage, localSetStorage, loginLocalStorage, resLoginStorageProps } from '@/lib/storage';
import { useAuthInfoActions, usePinInfo } from '@/store/zustand/store';
import { decryptData, encryptData } from '@/lib/Cryptos';
import { addNow, addProps, diffNow } from '@/lib/timer';
import { COIN_NAME_NFT, COIN_NAME_SFL, COIN_NAME_TRI } from '@/lib/common/name-space';
/**
 * pinType
 *  setting: sns??? 핀번호 등록 및 재설정
 *  check: 핀번호 확인???
 *  confirm: 전송 전 핀 번호 확인
 *  login: 셔플 id 대신 핀번호 로그인 (sns 로그인 불가)
 *  reset: 셔플 회원 핀 번호 잊어버림
 *  update: 셔플 회원 핀번호 다시 설정
 */
export type PinComponentProps = {
  pinType: 'setting' | 'check' | 'confirm' | 'login' | 'reset' | 'update';
  title: string;
  returnUrl: string;
  options?: {
    // 전송관련
    coin: string; // SFL, TRI, NFT
    type: string; // base, erc20, erc721
    contractAddress: string; // 컨트랙트 주소
    // 셔플회원 핀 번호 잊어버렸을 때 이메일로 인증 후 핀 번호 초기화
    email: string; // email있으면 SendMailDrawer 생성
    emailAuthNo: string;
    // check 사용 관련 타입
    check: 'authLevel' | 'security';
  };
};

export default function PinComponent() {
  const {
    state: { pinType, title, returnUrl, options },
  } = useLocation();
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [secretNumberConfirm, setSecretNumberConfirm] = useState('');
  const [secretNumber, setSecretNumber] = useState('');
  const [isSend, setIsSend] = useState(false);
  const [openSendMailDrawer, setOpenSendMailDrawer] = useState(false);
  const navigate = useNavigate();
  const { setAuthInfo } = useAuthInfoActions();
  const { checkCacheStatus } = useCacheBuster();
  const { web3authCall } = useWeb3();
  const pinInfo = usePinInfo();

  const { isConnected } = useWeb3AuthConnect();
  const { getUserInfo } = useWeb3AuthUser();

  const initStatus = () => {
    setIsConfirmed(false);
    setSecretNumber('');
    setSecretNumberConfirm('');
  };

  const onSuccess = async () => {
    if (pinType === 'setting') {
      isConfirmed === true ? snsPinSetting() : setIsConfirmed(true);
    } else if (pinType === 'check') {
      // await checkPin();
      // 핀 체크 관련 넣게
      // setting으로 이동도 있고
      // securityCenter로 이동하는 것이 있음 잘 확인 할 것
    } else if (pinType === 'login') {
      await pinLoginSuccess();
    } else if (pinType === 'confirm') {
      await confirmPin();
    } else if (pinType === 'reset') {
      isConfirmed === true ? await resetPin() : setIsConfirmed(true);
    } else if (pinType === 'update') {
      isConfirmed === true ? await updatePinNum() : setIsConfirmed(true);
    }
  };

  const snsPinSetting = async () => {
    if (secretNumber !== secretNumberConfirm) {
      toast.error(`핀번호가 일치하지 않습니다.`);
      initPin();
      initStatus();
      return;
    }
    const data = (process.env.REACT_APP_CRYPTO_SOLT as string) + IDTOKEN;
    if (isConnected) {
      const re = await getUserInfo();
      const loginType = re?.authConnection ?? 'external';
      const snsPayload = {
        key: 'snsAddress',
        value: {
          pinNum: encryptData(secretNumberConfirm, data),
          bio: null,
          isBio: false,
          typeOfLogin: loginType,
          failCount: 5,
          failExpire: '',
        },
      };
      localSetStorage(snsPayload);
    }

    toast.success('핀번호 등록 성공하였습니다.');
    setTimeout(() => {
      navigate(returnUrl);
    }, 1500);
  };
  // const checkPin = async () => {
  //   if (isWeb3) {
  //     const value = (process.env.REACT_APP_CRYPTO_SOLT as string) + IDTOKEN;
  //     const re = localGetStorage('snsAddress');
  //     const decPin: string = decryptData(re.pinNum, value);
  //     if (re.failExpire && diffNow(re.failExpire) < 0) {
  //       toast.error('5회 인증 실패로 24시간 동안 핀번호 사용이 불가능합니다.');
  //       initPin();
  //       resetSnsPinCheck(re);
  //       return;
  //     }
  //     if (Number(decPin) !== Number(secretNumber)) {
  //       toast.error(`핀번호가 일치하지 않습니다.`);
  //       initPin();
  //       failCountWeb3User();
  //       return;
  //     }
  //     resetSnsPinCheck(re);
  //   } else {
  //     const res = await chkPin(secretNumber);
  //     if (res.ret_code === 450) {
  //       setPinExceed();
  //     }
  //     if (res.ret_code !== 200) {
  //       ErrorRes({ code: res.ret_code, msg: res.msg, path: 'pinCheck', isBack: false });
  //       setSecretNumber('');
  //       return;
  //     }
  //   }

  //   const payload = {
  //     pinNum: secretNumber,
  //     path,
  //     active: true,
  //   };
  //   dispatch(setPinInfo(payload));
  //   initStatus();
  //   navigate(path, {
  //     state: {
  //       ...state,
  //       // pinType: 'update',
  //       // title: '핀 번호 세팅',
  //       // returnUrl: returnUrl,
  //     },
  //   });
  // };
  const pinLoginSuccess = async () => {
    const re: resLoginStorageProps = loginLocalStorage();
    if (!re) {
      toast.error('아이디, 비밀번호 입력 후 접근이 가능합니다.');
      return;
    }
    const payload: loginProps = {
      email: String(re.email),
      pin_pw: secretNumber,
    };
    const res = await pinLogin(payload);

    if (res.code !== 200) {
      ErrorRes({ code: res.code, msg: res.msg, path: 'pinSignIn', isBack: false });
      setSecretNumber('');
      return;
    }
    if (!res.data) {
      return;
    }
    checkCacheStatus();
    updatePushToken();
    setAuthInfo(res!.data.value);
    const email = re.email;
    keepEmail(email, false, 'pin');
    localSetStorage(res!.data);
    navigate(returnUrl); // wallet
  };
  const confirmPin = async () => {
    // sns 유저
    const value = (process.env.REACT_APP_CRYPTO_SOLT as string) + IDTOKEN;
    const re = localGetStorage('snsAddress');
    const decPin: string = decryptData(re.pinNum, value);
    console.log('pincheck');
    if (re.failExpire && diffNow(re.failExpire) < 0) {
      toast.error('5회 인증 실패로 24시간 동안 핀번호 사용이 불가능합니다.');
      initPin();
      const snsPayload = {
        key: 'snsAddress',
        value: {
          ...re,
          failCount: 5,
        },
      };
      localSetStorage(snsPayload);
      return;
    }
    if (Number(decPin) !== Number(secretNumber)) {
      toast.error(`핀번호가 일치하지 않습니다.`);
      initPin();
      failCountWeb3User();
      return;
    }

    setIsSend(true);
  };

  const resetPin = async () => {
    const payload = {
      email: options.email,
      email_auth_no: options.emailAuthNo,
      pin_num: secretNumber,
    };
    const re = await resetPinNum(payload);
    if (re.ret_code !== 200) {
      toast.error('핀번호가 일치하지 않습니다.');
      initPin();
      return;
    }
    toast.success('핀번호 변경 성공');
    navigate(returnUrl);
  };
  const failCountWeb3User = () => {
    const re = localGetStorage('snsAddress');
    let expire = null;
    if (Number(re.failCount) - 1 <= -1) {
      const payload: addProps = {
        num: 1,
        type: 'd',
      };
      expire = addNow(payload);
    }
    const snsPayload = {
      key: 'snsAddress',
      value: {
        ...re,
        failCount: Number(re.failCount) - 1,
        failExpire: expire,
      },
    };
    localSetStorage(snsPayload);
  };

  const updatePinNum = async () => {
    const payload = {
      bf_pin_num: pinInfo.pinNum,
      pin_num: secretNumberConfirm,
    };
    const re = await updatePin(payload);
    if (re.ret_code !== 200) {
      ErrorRes({ code: re.ret_code, msg: re.msg, path: 'PinSetting', isBack: false });
      setSecretNumber('');
      setSecretNumberConfirm('');
      setIsConfirmed(false);
      return;
    }
    toast.success('성공');
    navigate('/authLevel');
  };
  const initPin = () => {
    setSecretNumber('');
    setIsSend(false);
  };

  const SendType = () => {
    console.log(options.coin);
    if (options.coin === COIN_NAME_NFT) {
      console.log(`Erc721Token`);
      return <Erc721Token />;
    } else if (options.coin !== COIN_NAME_NFT && options.contractAddress) {
      console.log(`Erc20Token`);
      return <Erc20Token contractAddress={options.contractAddress} symbol={options.coin} />;
    } else {
      console.log('BaseCoin');
      return <BaseCoin symbol={options.coin} />;
    }
  };
  return (
    <>
      {isSend ? (
        SendType()
      ) : (
        // options.coin === COIN_NAME_TRI ? (
        //   <Erc20Token contractAddress={options.options} symbol={options.symbol} />
        // ) : options.coin === COIN_NAME_SFL ? (
        //   <BaseCoin symbol={options.symbol} />
        // ) : options.coin === COIN_NAME_NFT ? (
        //   <Erc721Token />
        // ) : (
        //   <>@@##$$ 전송 실패 뒤로 돌아가기</>
        // )
        <Container maxWidth="sm">
          <TopBackButton title={title} />
          <Box pt={4}>
            {web3authCall?.connected() ? (
              <>※ 핀번호 분실 시 셔플 앱을 삭제하고 새로 설치하신 후 재설정하시기 바랍니다.</>
            ) : (
              ''
            )}
            {isConfirmed ? (
              <>
                <Typography variant="h4" mb={2.5}>
                  <b>PIN번호 6자리</b>를
                  <br />
                  다시 입력해 주세요.
                </Typography>
              </>
            ) : (
              <Typography variant="h4" mb={5}>
                <br />
                <b>PIN번호 6자리</b>를 입력해 주세요.
              </Typography>
            )}
            <SecretNumberDisplay value={isConfirmed ? secretNumberConfirm : secretNumber} />
            <Box position="absolute" bottom={0} left={0} mb={2}>
              <RandomKeypad
                value={isConfirmed ? secretNumberConfirm : secretNumber}
                onChange={isConfirmed ? setSecretNumberConfirm : setSecretNumber}
                onSuccess={async () => {
                  await onSuccess();
                }}
              />
            </Box>
          </Box>
        </Container>
      )}

      {/* {isSend &&
        (options.coin === COIN_NAME_TRI ? (
          <Erc20Token contractAddress={options.options} symbol={options.symbol} />
        ) : options.coin === COIN_NAME_SFL ? (
          <BaseCoin symbol={options.symbol} />
        ) : options.coin === COIN_NAME_NFT ? (
          <Erc721Token />
        ) : (
          <>@@##$$ 전송 실패 뒤로 돌아가기</>
        ))} */}
    </>
  );
}
